import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const ButtonLabel = ({ className, onClick, active, rounded, disabled, style, text }) => {
  const handleClick = (e) => {
    return !disabled && onClick(e);
  };

  const classNameList = [className, 'btn-label'];

  if (rounded) {
    classNameList.push('rounded');
  }

  if (disabled) {
    classNameList.push('btn-disabled');
  }

  return (
    <div className={classNameList.join(' ')} style={style} onClick={handleClick} active={active ? 'true' : undefined}>
      {text}
    </div>
  );
};

ButtonLabel.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  rounded: PropTypes.bool,
  active: PropTypes.bool,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

ButtonLabel.defaultProps = {
  className: '',
  disabled: false,
  rounded: false,
  active: false,
  text: '',
  style: {},
  onClick: () => {},
};

export { ButtonLabel };
